import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import { faExternalLinkAlt, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { auroMetalSaurus, squidInk } from 'lib/css/colors';
import { BRANDS_PRODUCTS } from 'lib/networking/endpoints';
import sharedStyles from 'components/manage_brands/brand_verify/sharedStyles';
import useGet from 'lib/hooks/useGet';

function SampleProductsList({ brand }) {
  const { data: { brand_products = [] } = {} } = useGet(
    BRANDS_PRODUCTS,
    {
      brand_id: brand?.id,
      limit: 5,
      offset: 0,
      manufacturer_id: undefined,
      vendor_id: undefined,
    },
    !brand?.id,
  );
  return (
    <div className="mb-4">
      <div className={css(sharedStyles.fieldLabel)}>SAMPLE PRODUCTS</div>
      <ul className={css(styles.sampleProductsList)}>
        {brand_products.map(product => (
          <li key={product.id} className={css(styles.sampleProduct)}>
            <FontAwesomeIcon icon={faQuestionCircle} className={css(styles.sampleProductIcon)} />
            <span>{product.name}</span>
            <FontAwesomeIcon
              icon={faExternalLinkAlt}
              className={css(styles.sampleProductExternalIcon)}
              onClick={() => {}}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

const styles = StyleSheet.create({
  sampleProductsList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  sampleProduct: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 0',
    fontSize: '0.9rem',
    color: squidInk,
  },
  sampleProductIcon: {
    color: auroMetalSaurus,
    marginRight: 8,
  },
  sampleProductExternalIcon: {
    marginLeft: 'auto',
    color: auroMetalSaurus,
    fontSize: '0.75rem',
  },
});

SampleProductsList.propTypes = {
  brand: PropTypes.object.isRequired,
};

export default SampleProductsList;
